module.exports = __webpack_public_path__ + "static/media/ico-aguardando.e7e50693.svg";